module.exports = __webpack_public_path__ + "static/media/loading.d62e2943.svg";